import EventEmitter from 'events';
import { $window } from '@umu/umu-dom';

export const commonHeaderEventEmitter = new EventEmitter();

export const registerCommonHeaderEventEmitterForWindow = () => {
    ($window as any).commonHeaderEventEmitter = commonHeaderEventEmitter;
};
